import BadSide from "../../assets/img/new-home-page/slider/Badside.png";
import Sidelines from "../../assets/img/new-home-page/slider/sidelines.png";
import Ambulance from "../../assets/img/new-home-page/slider/Ambulance.png";
import ER from "../../assets/img/new-home-page/slider/ER.png";
import OldHome from "../../assets/img/new-home-page/slider/Old-home.png";

const gridItems = [
  {
    src: BadSide,
    title: "In Hospital",
    description:
      "CenSyn PenEEG can be used inside healthcare organizations either bedside or on-the go, within the ICU or Emergency departments.",
    buttonText: "Case study coming soon",
    buttonColor: "#00A9AC",
  },
  {
    src: Sidelines,
    title: "Sidelines",
    description:
      "CenSyn PenEEG can be used on the sidelines of sports games for real time concussion screening an athlete triage to the hospital.",
    buttonText: "Case study coming soon",
    buttonColor: "#FF52B0",
  },
  {
    src: Ambulance,
    title: "Emergency",
    description:
      "CenSyn PenEEG can be used on during emergency situations to collect real-time brain data outside the hospital to accelerate treatments.",
    buttonText: "Case study coming soon",
    buttonColor: "#B4B4B4",
  },
];

const GridLayout = () => {
  return (
    <div className="tw-container tw-mx-auto tw-px-10 sm:tw-px-4">
      <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-6 tw-max-w-6xl tw-mx-auto">
        {gridItems.map((item, index) => (
          <div
            key={index}
            className="tw-bg-white tw-rounded-lg tw-shadow-lg tw-overflow-hidden tw-transition-transform tw-duration-300 hover:tw-transform hover:tw-scale-105"
          >
            {/* Image Container */}
            <div className="tw-relative tw-h-48 tw-w-80 tw-mt-6">
              <div className="tw-rounded-lg tw-overflow-hidden tw-bg-white tw-h-full tw-w-full">
                <img
                  src={item.src}
                  alt={item.title}
                  className="tw-w-full tw-h-full tw-object-contain"
                />
              </div>
            </div>

            {/* Content Container */}
            <div className="tw-p-4 tw-mb-10">
              <h3 className="tw-text-xl tw-font-bold tw-mb-3 tw-text-gray-800">
                {item.title}
              </h3>
              <p className="tw-text-gray-600 tw-mb-4 tw-text-sm tw-leading-relaxed tw-min-h-[80px]">
                {item.description}
              </p>
              <span
                className={`tw-text-white tw-px-6 tw-py-2 tw-rounded-full tw-font-semibold tw-text-sm tw-inline-block tw-text-center ${"tw-bg-[#00A9AC]"}`}
              >
                {item.buttonText}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default GridLayout;
